import { render, staticRenderFns } from "./headingBlock.vue?vue&type=template&id=46fac330&scoped=true"
import script from "./headingBlock.vue?vue&type=script&lang=js"
export * from "./headingBlock.vue?vue&type=script&lang=js"
import style0 from "./headingBlock.vue?vue&type=style&index=0&id=46fac330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fac330",
  null
  
)

export default component.exports